import * as React from 'react';
import { Svg } from './Svg';
import { createComponent } from '@workday/canvas-kit-react/common';
export const Icon = createComponent('span')({
    displayName: 'Icon',
    Component: ({ src, size, styles, type, shouldMirror, ...elemProps }, ref, Element) => {
        var _a;
        const iconStyles = { ...styles };
        if (size) {
            iconStyles['& svg'] = {
                ...((_a = iconStyles['& svg']) !== null && _a !== void 0 ? _a : {}),
                width: size,
                height: size,
            };
        }
        return (React.createElement(Svg, Object.assign({ src: src, type: type, shouldMirror: shouldMirror, as: Element }, elemProps, { ref: ref, styles: iconStyles })));
    },
});
